import React from "react";
import "./style.css";

export default function CookiesPolicy() {
  return (
    <div className="cookies_bg">
      {/* Banner */}
      <div className="cookies_banner">{/* <h1>Cookie Policy</h1> */}</div>

      {/* Content */}
      <div className="cookies_content">
        <h1>User Data & Cookie Policy- Importerr.com</h1>
        <h3>(Boundless Trends Pvt. Ltd.)</h3>

        <p>
          Governing Law: Indian Laws including the Information Technology Act, 2000 and the Digital Personal Data Protection Act, 2003 (as and when notified).
        </p>

        <section>
          <h2 className="cookies_heading">1. Introduction</h2>
          <p>
            This Cookie Policy sets out how Importerr.com deploys cookies and similar data collection tools on its digital platform for the collection, storage, and processing for user data, strictly for lawful and legitimate purposes, in a manner consistant with applicable Indian laws. 
          </p>
        </section>

        <section>
          <h2 className="cookies_heading">2. What are Cookies?</h2>
          <p>Cookies are small text files stored on your device to improve website functionality, understand how users interact with the site, personalize content, and analyze traffic, for a smooth user experience.</p>
        </section>

        <section>
          <h2 className="cookies_heading">3. Types of Cookies We Use</h2>
          <ul className="cookies_list">
            <li>Essential Cookies: Required for core platform functions.</li>
            <li>Performance Cookies: Track usage patterns to improve services.</li>
            <li>Functional Cookies: Remember user preferences and settings.</li>
            <li>Advertising Cookies: Deliver relevant ads and measure effectiveness.</li>
            <li>Third-Party cookies: used by embedded content, ads, or analytics platforms.</li>
          </ul>
        </section>

        <section>
          <h2 className="cookies_heading">4. How We Use Cookies?</h2>
          <p>We use cookies for:</p>
          <ul className="cookies_list">
            <li>User Authentication and Sessions Management.</li>
            <li>Remembering user preferences and order retention.</li>
            <li>Analyzing traffic and user behavior.</li>
            <li>Personalized marketing.</li>
            <li>Prevent fraudulent activity and promoting user security.</li>
          </ul>
        </section>

        <section>
          <h2 className="cookies_heading">5. Managing Cookies</h2>
          <p>
            Users may withdraw their consent to the use of non-essential cookies at any time by following the method specified in our Cookie Consent Tool or through their browser settings. However, such withdrawal shall not affect the lawfulness of any data processing carried out prior to the withdrawal. Users acknowledge that disabling or withdrawing consent for certain cookies may affect website functionality, and any resulting limitations or issues shall be borne solely by the user.
          </p>
        </section>

        <section>
          <h2 className="cookies_heading">6. Third-Party Cookies</h2>
          <p>
            Some cookies are placed by third-party services (e.g., analytics, ads). Importerr.com is not responsible or liable for third-party cookie practices, in any manner whatsoever.
          </p>
          <br />
          <b><p>Some cookies on this website are set by third-party service providers (such as those used for analytics and advertising). Importerr.com does not control and is not responsible or liable for the cookie practices, policies, or data handling procedures of such third parties. Users are advised to review the respective privacy and cookie policies of these third-party providers, at their own risk and consequences.</p></b>
        </section>

        <section>
          <h2 className="cookies_heading">7. User Consent</h2>
          <p>
            By continuing to use Importerr.com, you unconditionally and unequivocally consent to our use of cookies and processing of userdata in accordance with this policy for above specified purposes.
          </p>
        </section>

        <section>
          <h2 className="cookies_heading">8. Changes to Cookie Policy</h2>
          <p>
            We may update this Cookie Policy from time to time. Continued use of our platform constitutes acceptance of changes any change in cookie policy shall be deemed accepted by user unless withdrawn by such user.
          </p>
        </section>
      </div>
    </div>
  );
}
